/* eslint-disable @typescript-eslint/non-nullable-type-assertion-style */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable typescript-sort-keys/interface */
import type { AxiosResponse } from 'axios'
import dayjs, { type Dayjs } from 'dayjs'

import axiosInstance from '@/axios'
import {
  type EApplicationType,
  type EApplicationStatus,
  type TApplication,
} from '@/interfaces'

import { ConvocatoriasState } from '../convocatorias'
import { FormState } from '../form'

import { ApplicationsState } from '.'

interface TChangeStatusBody {
  data: {
    statusName: EApplicationStatus
    enddate?: string
  }
  entity: string
}

const applicationRequests = {
  changeApplicationStatus: async (
    newStatus: EApplicationStatus,
    applicationId: string | number
  ): Promise<AxiosResponse<TApplication>> => {
    const bodyData: TChangeStatusBody = {
      data: {
        statusName: newStatus,
      },
      entity: 'CSolicitud',
    }

    // if (newStatus === EApplicationStatus.CORRECTLY_FILLED) {
    //   bodyData.data.enddate = dayjs().format('YYYY-MM-DD')
    // }

    return await axiosInstance.put(`/general/update/${applicationId}`, bodyData)
  },
  createNewApplication: async (): Promise<
    AxiosResponse<{ id: string; consecutivoHogar: number }>
  > => {
    const currentTeamId = ConvocatoriasState.currentCity.peek() as string
    const currentCity =
      ConvocatoriasState.cities
        .peek()
        .find((item) => item.value === currentTeamId)
        ?.label.toUpperCase() ?? ''

    return await axiosInstance.post('/general/save', {
      data: {
        addressCity: currentCity,
        convocatoriaId: ConvocatoriasState.currentConvocatoria.value.id,
        teamsIds: [currentTeamId],
        typeimprovement: ApplicationsState.currentApplicationType.peek(),
      },
      entity: 'CSolicitud',
    })
  },
  createRowData: async (
    rowData: TApplication
  ): Promise<AxiosResponse<{ id: string }>> => {
    return await axiosInstance.post('/general/save', {
      data: rowData,
      entity: FormState.currentEntity.value?.name,
      id: ApplicationsState.currentApplication.value?.id,
    })
  },
  deleteApplication: async (
    applicationId: string
  ): Promise<AxiosResponse<{ id: string }>> => {
    return await axiosInstance.post('/general/delete', {
      entity: 'CSolicitud',
      id: applicationId,
    })
  },
  deleteRowData: async (
    rowDataId: string | number
  ): Promise<AxiosResponse<{ id: string | number }>> => {
    return await axiosInstance.post('/general/delete', {
      entity: FormState.currentEntity.value?.name,
      id: rowDataId,
    })
  },
  exportData: async (convocatoriaId: string): Promise<Blob> => {
    return await axiosInstance.post(
      '/general/downloaddata',
      { convocatoriaId },
      { responseType: 'blob' }
    )
  },
  getAllApplications: async (): Promise<AxiosResponse<TApplication[]>> => {
    return await axiosInstance.get('/application/get/all')
  },
  getApplicationData: async (
    applicationId: string | number
  ): Promise<AxiosResponse<TApplication>> => {
    return await axiosInstance.get(`/application/get/id/${applicationId}`)
  },
  getApplicationStatus: async (
    applicationId: string
  ): Promise<AxiosResponse<{ estadoName: string }>> => {
    return await axiosInstance.get(`/application/get/status/${applicationId}`)
  },
  importData: async (
    convocatoriaId: string,
    teamId: string,
    archivoBase64: string,
    type: EApplicationType
  ): Promise<{ solicitudId: string }> => {
    return await axiosInstance.post('/general/importdata', {
      archivoBase64,
      convocatoriaId,
      teamId,
      type,
    })
  },
  saveApplicationData: async (
    applicationData: TApplication,
    entityId?: string | number
  ): Promise<AxiosResponse<{}>> => {
    if (applicationData.visitDate) {
      applicationData.visitDate = dayjs(
        applicationData.visitDate as string | Dayjs
      ).format('YYYY-MM-DD HH:mm:ss')
    }
    return await axiosInstance.post('/general/save', {
      data: applicationData,
      entity: FormState.currentEntity.value?.name,
      id: entityId ?? ApplicationsState.currentApplication.value?.id,
    })
  },
  syncApplications: async (
    applications: TApplication[]
  ): Promise<AxiosResponse<Array<string | null>>> => {
    return await axiosInstance.post('/entity/execute/offline/crm', applications)
  },
  syncDeletedApplications: async (
    applicationsIds: string[]
  ): Promise<AxiosResponse<{ success: boolean }>> => {
    return await axiosInstance.post(
      '/entity/execute/delete/offline/crm',
      applicationsIds
    )
  },
  updateRowData: async (
    rowData: TApplication
  ): Promise<AxiosResponse<{ id: string }>> => {
    return await axiosInstance.put(`/general/update/${rowData?.id as string}`, {
      data: rowData,
      entity: FormState.currentEntity.value?.name,
      id: ApplicationsState.currentApplication.value?.id,
    })
  },
}

export default applicationRequests
